import type { SearchResponseFields } from '../types';
import { isEmpty, isNil } from 'ramda';

export const buildAnalyticsActiveFilters = (
  rawFilters: Record<string, any> | null | undefined,
  fields: SearchResponseFields | null,
): Record<string, any> => {
  const searchResponseFilters = isNil(rawFilters) || isEmpty(rawFilters) ? undefined : rawFilters;
  let searchActiveFilters: Record<string, any> = { ...searchResponseFilters };

  if (
    searchActiveFilters.priceSection &&
    !searchActiveFilters.priceSection.weddingBudget &&
    !searchActiveFilters.priceSection.venueHirePrice
  ) {
    const priceBracket = Object.keys(searchActiveFilters.priceSection);
    searchActiveFilters = { ...searchActiveFilters, priceSection: { priceBracket } };
  }

  const { radiusIncrease, capacityDining, accommodationRooms } = fields ?? {};
  if (radiusIncrease || capacityDining || accommodationRooms) {
    searchActiveFilters = {
      ...searchActiveFilters,
      misc: { ...searchActiveFilters.misc, radiusIncrease, capacityDining, accommodationRooms },
    };
  }

  if (fields?.hasLateAvailability) {
    searchActiveFilters = {
      ...searchActiveFilters,
      specialOffers: {
        ...searchActiveFilters.specialOffers,
        hasLateAvailability: fields.hasLateAvailability,
      },
    };
  }

  return searchActiveFilters;
};
